<template>
  <div class="w-full flex flex-1">

    <pt-popover placement="bottom">
      <div class="px-4 cursor-pointer">{{ selectedRangeTypeText }}<i class="pt-4 ml-2 fa fa-caret-down" /></div>
      <div
        slot="body"
        class="p-4 flex flex-col"
      >
        <pt-radio-group
          v-model="selectedDateRangeType"
          :options="radioOptions"
          :is-horizontal="false"
          name="fruit-horizontal"
          class="flex w-full"
          @input="onOptionSelected"
        />
        <pt-datepicker
          v-if="showDatepicker"
          range
          class="mt-4"
          @selected="emitDates"
        />
      </div>
    </pt-popover>
    <div class="flex-1" />
  </div>
</template>

<script>
import { PtRadioGroup } from '@pathao/ui-components/esm/FormComponents';
import { PtPopover } from '@pathao/ui-components/esm/Popover';
import { PtDatepicker } from '@pathao/ui-components/esm/Datepicker';

import startOfWeek from 'date-fns/start_of_week';
import startOfMonth from 'date-fns/start_of_month';
import formatDate from '@src/utils/format-date';

const ISO_DATE_TIME_STR = 'YYYY-MM-DD';
const DATE_RANGE_TYPES = {
  TODAY: {
    value: 'today',
    label: 'Today',
  },
  WEEK: {
    value: 'week',
    label: 'This Week',
  },
  MONTH: {
    value: 'month',
    label: 'This Month',
  },
  CUSTOM: {
    value: 'custom',
    label: 'Custom Date Range',
  },
};
export default {
  name: 'DateRangeSelector',
  components: { PtRadioGroup, PtPopover, PtDatepicker },
  data() {
    return {
      selectedDateRangeType: DATE_RANGE_TYPES.TODAY.value,
      radioOptions: [DATE_RANGE_TYPES.TODAY, DATE_RANGE_TYPES.WEEK, DATE_RANGE_TYPES.MONTH, DATE_RANGE_TYPES.CUSTOM],
      showDatepicker: false,
    };
  },
  computed: {
    selectedRangeTypeText() {
      if (this.selectedDateRangeType === DATE_RANGE_TYPES.TODAY.value) {
        return 'Today';
      } else if (this.selectedDateRangeType === DATE_RANGE_TYPES.WEEK.value) {
        return 'This Week';
      } else if (this.selectedDateRangeType === DATE_RANGE_TYPES.MONTH.value) {
        return 'This Month';
      } else {
        return 'Custom';
      }
    },
  },
  mounted() {
    this.emitDates();
  },
  methods: {
    onOptionSelected(selectedOption) {
      this.selectedDateRangeType = selectedOption;
      this.showDatepicker = selectedOption === DATE_RANGE_TYPES.CUSTOM.value;

      if (!this.showDatepicker) {
        this.emitDates();
      }
    },
    emitDates(customDateRange) {
      const dates = {};
      dates['date_range_end'] = formatDate(new Date(), ISO_DATE_TIME_STR);

      if (this.selectedDateRangeType === DATE_RANGE_TYPES.TODAY.value) {
        dates['date_range_start'] = formatDate(new Date(), ISO_DATE_TIME_STR);
      } else if (this.selectedDateRangeType === DATE_RANGE_TYPES.WEEK.value) {
        dates['date_range_start'] = formatDate(startOfWeek(new Date()), ISO_DATE_TIME_STR);
      } else if (this.selectedDateRangeType === DATE_RANGE_TYPES.MONTH.value) {
        dates['date_range_start'] = formatDate(startOfMonth(new Date()), ISO_DATE_TIME_STR);
      } else if (this.selectedDateRangeType === DATE_RANGE_TYPES.CUSTOM.value && customDateRange.from && customDateRange.to) {
        dates['date_range_start'] = formatDate(customDateRange.from, ISO_DATE_TIME_STR);
        dates['date_range_end'] = formatDate(customDateRange.to, ISO_DATE_TIME_STR);
      }

      this.$emit('date-selected', dates);
    },
  },
};
</script>
